export const FEATURE_LABORATORY_PRODUCTION_URL = 'https://app.marqii.com/api/v2/lab'
export const FEATURE_LABORATORY_DEVELOPMENT_URL =
  'http://featu-devpr-e307gct5laeq-1913669503.us-east-1.elb.amazonaws.com/proxy'
export const DASHBOARD_APP_NAME = 'dashboard'
export const DASHBOARD_CLIENT_KEY = 'LZNqLHTuxg7DKUQGtDXM'
